'use client';

import { useEffect } from 'react';
import { installSessionAuthFetch } from '@/lib/clientSessionFetch';

// Installs the session-auth fetch wrapper as early as possible on the client.
// Runs once; subsequent mounts are no-ops (guarded inside installSessionAuthFetch).
export default function SessionAuthInstaller() {
  useEffect(() => {
    installSessionAuthFetch();
  }, []);
  return null;
}
